import React from 'react';
import './style.css';

class About extends React.Component{
    render(){
        return(
           
          <section className="text-center about">
            <h1>关于我们</h1>
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-ex-12 about-item wow lightSpeedIn" data-wow-offset="200" >
                  {/*
                  <h2>月与田科技</h2>
                  */}                  
                  <p className="lead">
                  免费好用的短视频工具箱，可以一键去水印、下载短视频。
                  </p>
                  <p className='lead'>
                  一切资源来源于互联网，请遵守原创及相关要求。
                  </p>
                </div>
                <div className="col-lg-4 col-sm-6 col-ex-12 about-item wow lightSpeedIn" data-wow-offset="200">
                  {/*
                  <h2>Version </h2>
                  <h2 class ="v">1.0</h2>
                  */}
                </div>
                <div className="clearfix visible-md-block visible-sm-block"></div>
                <div className="col-lg-4 col-sm-6 col-ex-12 about-item wow lightSpeedIn" data-wow-offset="200">
          
                {/*
                <h2>Releasing year</h2>
                <h2 class="v">2023</h2>
                */}
                </div>
        
              </div>
      
            </div>
          </section>
        )
    }
}
export  default About